import React from 'react';
import { Link } from 'gatsby';
import styled from '@emotion/styled';

import Button from '../../../ui/BaseButton';
import { COLORS } from '../../../ui/variables';

const Container = styled.nav`
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-weight: 600;
  height: 100%;
`;

const JoinBtn = styled(Button)`
  padding: 0 30px;
  height: 48px;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

const MainLinks = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
`;

const NavLink = styled(Link)`
  transition: color 200ms ease;
  color: ${COLORS.BLACK};
  text-decoration: none;

  &:hover {
    color: ${COLORS.DARK_GRAY};
  }
`;

const PaddedLink = styled(NavLink)`
  margin: 0 20px;
`;

interface Props {
  className?: string;
  v2colors?: boolean;
  cta: {
    text: string;
    to?: string;
    href?: string;
  };
}

const Navigation = ({ className, v2colors, cta }: Props) => {
  return (
    <Container className={className}>
      <MainLinks>
        <PaddedLink type='internal' to='/plans'>
          Plans
        </PaddedLink>

        <PaddedLink type='internal' to='/locations'>
          Locations
        </PaddedLink>
      </MainLinks>

      <Actions>
        <JoinBtn
          type='external'
          href={cta.href}
          color={v2colors ? COLORS.NEW_ORANGE : COLORS.ORANGE}
        >
          {cta.text}
        </JoinBtn>
      </Actions>
    </Container>
  );
};

export default Navigation;
